module.exports = __webpack_public_path__ + "img/pharma-bags-prime.b918206b.png";